<mat-form-field appearance="outline" style="height: 100%">
  @if (label) {
    <mat-label>{{ label }}</mat-label>
  }

  <textarea matInput [formControl]="control" [placeholder]="placeHolder"></textarea>
  @if (control.value && isClear === true) {
    <button style="display: flex; align-items: center" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
      <mat-icon>close</mat-icon>
    </button>
  }
</mat-form-field>
